/**
 * 休眠
 * @param ms 持续时间(毫秒)
 * @returns Promise<void>
 */
export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * 循环直到条件满足
 * @param condition 条件函数
 * @param interval 间隔时间(毫秒)
 * @param timeout 超时时间(毫秒)
 * @returns Promise<void>
 */
export function loopUntilCondition(
  condition: () => boolean | Promise<boolean>,
  interval: number = 500,
  timeout: number = 30 * 1000
): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | null = null

  return new Promise((resolve, reject) => {
    const start = Date.now()
    const loop = async () => {
      if (await condition()) {
        timer && clearTimeout(timer)
        resolve()
        return
      }

      if (Date.now() - start > timeout) {
        timer && clearTimeout(timer)
        reject(new Error('Timeout'))
        return
      }

      timer = setTimeout(loop, interval)
    }

    loop()
  })
}
